// extracted by mini-css-extract-plugin
export default {"info-message":"InfoMessage_info-message__l3P0k","error-message":"InfoMessage_error-message__Hhqc1","fade-out":"InfoMessage_fade-out__YrxYH"};